<template>
  <div class="list">
    <div class="table">
      <table-temp title :flag="1" :tableData="tableData" :columnData="tableConf" text="详情" :isEdit="false"
        @editTable="editTable" @handleSelectionCode="handleSelectionCode">
        <div slot="tool" class="listBtn">
          <el-button class="borderBtn" :class="{ active: active == item }" v-for="(item, index) of btnGroup"
            :type="item == 'new' ? 'primary' : null" :key="index" @click="changeType(item)">{{ flags[item]
            }}<i class="button-icon" :class="{
  'icon-xinshe': item == 'new',
  'icon-qianru': item == 'add',
  'icon-biangeng': item == 'update',
}"></i></el-button>
        </div>
        <template slot="other">
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="editTable(scope)">详情</el-button>
              <el-button type="text" size="small" @click="delTable(scope)" v-if="[0, 4].includes(scope.row.checkState)">
                删除</el-button>
              <el-button type="text" size="small" v-if="[0, 4].includes(scope.row.checkState)" @click="fillList(scope)">
                编辑</el-button>
              <el-button type="text" size="small" v-if="[3].includes(scope.row.checkState)"
                @click="changeStatus(scope)">变更</el-button>
            </template>
          </el-table-column>
        </template>
      </table-temp>
    </div>
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
        :page-sizes="[5, 10, 20]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
const flags = {
  new: "新设",
  update: "变更",
  add: "迁入",
};

import TableTemp from "@table/table1";
import { list } from "@/conf/newAgency";
import { getFundList, getDetailAgency,delMessage } from "common/js/api";
import { mapMutations } from "vuex";

export default {
  components: {
    TableTemp,
  },

  data() {
    return {
      flags,
      tableData: [],
      tableConf: list,
      // btnGroup: ["new", "update", "add"],
      btnGroup: ["new", "add"],

      active: "new",
      userCode: "",
      selectData: [],
      total: 0,
      currentPage: 1,
      pageSize: 5,
    };
  },
  //测试code JG863295
  mounted() {
    this.userCode = this.Cookies.get("identifyCode");

    this.getList();
  },

  methods: {
    async fillList(scope) {
      const codeId = scope.row.institutionCode;
      const checkState = scope.row.checkState
      const res = await getDetailAgency(codeId);
      this.setMgrData({
        codeId: codeId,
        value: res.result,
      });
      this.$router.push({
        path: "/FundAgency/Agency",
        query: {
          flag: "update",
          codeId: codeId,
          step: 0,
          checkState: checkState,
        },
      });
    },

    editTable(scope) {
      this.$router.push({
        path: "/FundAgency/FundDetail",
        query: {
          flag: this.active,
          institutionCode: scope.row.institutionCode,
        },
      });
    },
    delTable(scope) {
      this.idCode = scope.row.institutionCode;
      delMessage(this.idCode).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.getList();
        }
      });
    },
    changeType(item) {
      this.active = item;
      if (item == "update") {
        this.getUpdateDetail();
        return;
      }
      this.$router.push({
        path: "/FundAgency/Agency",
        query: {
          flag: item,
        },
      });
      // this.getList();
    },

    async getList() {
      const data = {
        userInstitutionCode: this.userCode,
        institutionType: "JJ",
        page: this.currentPage,
        size: this.pageSize,
      };
      this.changeLoadingstate(true);
      const { result } = await getFundList(data);

      this.tableData = result.list;
      this.total = result.total;
      this.currentPage = result.pageNum;
      this.pageSize = result.pageSize;
    },

    async changeStatus(scope) {
      const institution = scope.row;
      if (institution.checkState == 2) {
        this.$message({
          message: "抱歉!机构状态为审核中或待审核状态,不能进行变更",
          type: "warning",
        });
        return;
      }
      const codeId = institution.institutionCode;
      const res = await getDetailAgency(codeId);
      this.setMgrData({
        codeId: codeId,
        value: res.result,
      });
      this.$router.push({
        path: "/FundAgency/Agency",
        query: {
          flag: "update",
          codeId: codeId,
          step: 0,
        },
      });
    },

    //  未确定变更方式 先写第一条id
    async getUpdateDetail() {
      if (!this.checkState()) return;
      const institution = this.selectData[0];

      if (institution.checkState == 2) {
        this.$message({
          message: "抱歉!机构状态为审核中或待审核状态,不能进行变更",
          type: "warning",
        });
        return;
      }
      const codeId = institution.institutionCode;
      const res = await getDetailAgency(codeId);
      this.setMgrData({
        codeId: codeId,
        value: res.result,
      });
      this.$router.push({
        path: "/FundAgency/Agency",
        query: {
          flag: "update",
          codeId: codeId,
          step: 0,
        },
      });
    },

    checkState() {
      if (this.selectData.length > 1) {
        this.$message({
          message: "变更只支持同时变更一个机构,请选择一个机构进行变更!",
          type: "warning",
        });
        return false;
      }
      if (!this.selectData.length) {
        this.$message({
          message: "请选择机构进行变更!",
          type: "warning",
        });
        return false;
      }
      return true;
    },

    handleSelectionCode(codeList) {
      this.selectData = codeList;
    },

    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.getList();
    },

    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },

    ...mapMutations(["setMgrData", "changeLoadingstate"]),
  },
};
</script>

<style scoped lang="scss">
.table {
  /* margin-top: -52px !important; */
}

.list {
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 0px 4px 12px 0px #cccccc80;
  height: 100%;
  display: flex;
  overflow: auto;
  flex-direction: column;
  padding: 20px;

  >.table {
    flex: 1;
  }
}

.active {
  // background-color: #3165ff !important;
  // color: #ffffff !important;
}

::v-deep .type-title {
  &::before {
    display: none;
  }
}
</style>
